module.exports = __webpack_public_path__ + "static/media/tournament-builder-logo-header.b47043b2.png";